export default __webpack_public_path__ + "static/contact-image-text-f4b96e49d746bf0bba7c07f527d2882c.jpg";